import React, {useState, useEffect} from 'react';
import {notification, Button, Table, Row, Col, Tooltip} from 'antd';
import i18n from "../../../../i18n";
import Spinner from '../../../spinner';
import {distributionCenterService} from '../../../../services';
import ModalEditDistributionCenter from "../../../modals/edit-distribution-center";
import ModalCreateDistributionCenter from "../../../modals/create-distribution-center";
import ModalEditDistributionCenterOrderTimeSums from "../../../modals/edit-distribution-center-order-time-sums";
import ModalListOfGates from "../../../modals/gates-list";
import ModalListLoadingSchedule from "../../../modals/list-loading-shedule";
import ModalListUnloadingTime from '../../../modals/list-unloading-time';

export default function DistributionCentres({consignorSettings}) {

  const [loading, setLoading] = useState(true);
  const [isNeedUpdateList, setIsNeedUpdateList] = useState(true);
  const [data, setData] = useState([]);
  const [showModalEditDistCenter, setShowModalEditDistCenter] = useState(null);
  const [showModalEditOrderTimeSums, setShowModalEditOrderTimeSums] = useState(null);
  const [showModalCreateDistCenter, setShowModalCreateDistCenter] = useState(null);
  const [showModalListOfGates, setShowModalListOfGates] = useState(null);
  const [showModalListLoadingSchedule, setShowModalListLoadingSchedule] = useState(null);
  const [showModalLoadingTime, setShowModalLoadingTime] = useState(null);

  const [currentDistCenterId, setCurrentDistCenterId] = useState(null);
  const [currentDistCenterName, setCurrentDistCenterName] = useState(null);

  let bigButtonStyle = {
    color: 'white',
    backgroundColor: '#1CAA53',
    borderRadius: '7px',
    height: '35px',
    border: 'none'
  };

  useEffect(() => {
    if (isNeedUpdateList) {
      distributionCenterService.getCompanies()
        .then((response) => {

          const distributionsCentersData = response.map((item) => {
            return {
              id: item.Id,
              name: item.Name,
              delayDelivDispatcher: item.DelayDelivDispatcher,
              delayReserveDeliv: item.DelayReserveDeliv,
              maxCountLoadAuto: item.MaxCountLoadAuto,
              startFillingOrder: item.StartFillingOrder,
              fillingOrder: item.FillingOrder,
              downloadDocument: item.DownloadDocument,
              closingTime: item.ClosingTime,
              minOrdersToApprove: item.MinOrdersToApprove,
              minHoursToRefuse: item.MinHoursToRefuse,
              cargoCollectTime: item.CargoCollectTime,
              countSkipAvailableTimesNonImportantDelivery: item.CountSkipAvailableTimesNonImportantDelivery,
              importantDeliveryMaxTimeLoad: item.ImportantDeliveryMaxTimeLoad,
              maxInnerDistance: item.MaxInnerDistance,
            };
          });

          setIsNeedUpdateList(false);
          setLoading(false);
          setData(distributionsCentersData);

        }).catch((errMsg) => notification.error(
        {
          message: i18n.t('components.notification.titles.getDistributionCentersList'),
          description: errMsg
        }));
    }

  }, [isNeedUpdateList]);

  const columns = [
    {
      title: i18n.t('consignorPage.distributionCentres.table.name.title'),
      key: 'name',
      width: '25%',
      sorter: (a, b) => a.id - b.id,
      render: (data) => {
        return (
          <React.Fragment>
            <p className="column-title">{data.name}</p>
            <Tooltip title={i18n.t('consignorPage.distributionCentres.buttons.edit')}>
              <Button type="primary"
                      htmlType="button"
                      onClick={() => setShowModalEditDistCenter(data.id)}
                      size="small"
                      icon="edit"
                      style={{margin: '0 5px 10px 0'}}/>
            </Tooltip>
            <ModalEditDistributionCenter
              isShow={(showModalEditDistCenter === data.id)}
              onCloseModal={() => {
                setShowModalEditDistCenter(null);
                setLoading(true);
                setIsNeedUpdateList(true);
              }}
              {...data}
            />
            <Tooltip title={i18n.t('consignorPage.distributionCentres.buttons.up')}>
              <Button type="primary"
                      htmlType="button"
                      onClick={() => {
                        setShowModalEditOrderTimeSums(data.id);
                      }}
                      icon="arrow-up"
                      size="small"
                      style={{margin: '0 5px 10px 0'}}/>
            </Tooltip>
            <ModalEditDistributionCenterOrderTimeSums
              isShow={(showModalEditOrderTimeSums === data.id)}
              distCenterId={data.id}
              onCloseModal={() => {
                setShowModalEditOrderTimeSums(null);
                setLoading(true);
                setIsNeedUpdateList(true);
              }}
              {...data}
            />
            <Tooltip title={i18n.t('consignorPage.distributionCentres.buttons.gate')}>
              <Button type="primary"
                      htmlType="button"
                      onClick={() => {
                        setShowModalListOfGates(data.id);
                      }}
                      size="small"
                      style={{margin: '0 5px 10px 0'}}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 47.09"
                     focusable="false"
                     width="1em"
                     height="1em"
                     fill="currentColor"
                     aria-hidden="true"
                     style={{display: "inline-block", verticalAlign: "middle"}}>
                  <path d="M1.25 13.63h44.88v2.48H1.25z" fill="currentcolor"/>
                  <path d="M1.25 19.83h44.88v2.48H1.25z" fill="currentcolor"/>
                  <path d="M1.25 26.03h44.88v2.48H1.25z" fill="currentcolor"/>
                  <path d="M1.25 32.22h44.88v2.48H1.25z" fill="currentcolor"/>
                  <path d="M1.25 0h44.88v9.91H1.25z" fill="currentcolor"/>
                  <path d="M17.45 3.72h12.47V6.2H17.45z" fill="black" opacity="0.7"/>
                  <path d="M43.01 0H48v47.09h-4.99z" fill="currentcolor"/>
                  <path d="M0 0h4.99v47.09H0z" fill="currentcolor"/>
                </svg>
              </Button>
            </Tooltip>
            <ModalListOfGates
              isShow={(showModalListOfGates === data.id)}
              distCenterId={data.id}
              name={data.name}
              onCloseModal={() => {
                setShowModalListOfGates(null);
                setLoading(true);
                setIsNeedUpdateList(true);
              }}
              {...data}
            />
            <Tooltip title={i18n.t('consignorPage.distributionCentres.buttons.list')}>
              <Button type="primary"
                      htmlType="button"
                      style={{margin: '0 5px 10px 0'}}
                      onClick={() => {
                        setShowModalListLoadingSchedule(data.id);
                      }}
                      size="small"
                      icon="clock-circle"/>
            </Tooltip>
            <ModalListLoadingSchedule
              isShow={(showModalListLoadingSchedule === data.id)}
              distCenterId={data.id}
              name={data.name}
              onCloseModal={() => {
                setShowModalListLoadingSchedule(null);
              }}
              {...data}
            />
            <Tooltip title={i18n.t('consignorPage.distributionCentres.buttons.times')}>
              <Button type="primary"
                      htmlType="button"
                      onClick={() => {
                        setShowModalLoadingTime(true);
                        setCurrentDistCenterId(data.id);
                        setCurrentDistCenterName(data.name);
                      }}
                      size="small"
                      icon="car"/>
            </Tooltip>
          </React.Fragment>
        );
      },
    },
    {
      title: i18n.t('consignorPage.distributionCentres.table.delayDelivDispatcher.title'),
      dataIndex: 'delayDelivDispatcher',
      key: 'delayDelivDispatcher',
      width: '10%',
    },
    {
      title: i18n.t('consignorPage.distributionCentres.table.delayReserveDeliv.title'),
      dataIndex: 'delayReserveDeliv',
      key: 'delayReserveDeliv',
      width: '10%',
    },
    {
      title: i18n.t('consignorPage.distributionCentres.table.maxCountLoadAuto.title'),
      dataIndex: 'maxCountLoadAuto',
      key: 'maxCountLoadAuto',
      width: '10%',
    },
    {
      title: i18n.t('consignorPage.distributionCentres.table.startFillingOrder.title'),
      dataIndex: 'startFillingOrder',
      key: 'startFillingOrder',
      width: '10%',
    },
    {
      title: i18n.t('consignorPage.distributionCentres.table.fillingOrder.title'),
      dataIndex: 'fillingOrder',
      key: 'fillingOrder',
      width: '10%',
    },
    {
      title: i18n.t('consignorPage.distributionCentres.table.downloadDocument.title'),
      dataIndex: 'downloadDocument',
      key: 'downloadDocument',
      width: '10%',
    }
  ];

  return (
    <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
      <h1 className="content-header">{i18n.t('consignorPage.distributionCentres.title')}</h1>
      {(consignorSettings && !consignorSettings.isOwner) &&
        <Row gutter={48} style={{paddingRight: "0"}}>
          <Col span={24} style={{textAlign: "right", height: "40px", marginBottom: "24px"}}>
            <Button
              type="primary"
              htmlType="button"
              onClick={() => {
                setShowModalCreateDistCenter(true);
              }}
              style={{backgroundColor: "#1CAA53", border: "none", height: "100%"}}
            >
              {i18n.t('consignorPage.distributionCentres.buttons.add')}
            </Button>
          </Col>
        </Row>
      }
      <Table
        columns={columns}
        dataSource={data}
        locale={{emptyText: i18n.t('main.empty')}}
        rowKey="id"
        size="small"
        pagination={{
          pageSize: 50
        }}
      />
      <ModalCreateDistributionCenter
        isShow={showModalCreateDistCenter}
        onCloseModal={() => {
          setShowModalCreateDistCenter(null);
          setLoading(true);
          setIsNeedUpdateList(true);
        }}
      />
      <ModalListUnloadingTime
          isShow={showModalLoadingTime}
          distCenterId={currentDistCenterId}
          name={currentDistCenterName}
          onCloseModal={() => {
            setShowModalLoadingTime(null);
            setCurrentDistCenterId(null);
            setCurrentDistCenterName(null);
          }}
      />
    </Spinner>
  );
}
